import React, { useState, useEffect } from "react";
import { Grid, Typography, Button } from "@mui/material";
import Modal from "@instream-solutions/instream-design-system/lib/UX/Modal/Modal";
import {
  getAdvisorSecurityQuestion,
  getAdvisorSecurityQuestionList,
  saveSecurityQuestion,
} from "../../../api/shared/userProfile";
import { HIDE_SECURITY_QUESTION_MODAL } from "../../../redux/constants";
import { connect } from "react-redux";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import TextBox from "@instream-solutions/instream-design-system/lib/UX/TextBox/TextBox";
import "../../../pages/advisor/UserProfile/UserProfile.scss";

const SecurityQuestionModal = (props) => {
  const [state, setState] = useState({
    securityQuestionList: [],
    security: {
      question: {
        id: null,
        question: "",
      },
      answer: "",
      password: "",
    },
  });

  useEffect(() => {
    const currentUser = props.currentUser.toJS();
    const advisorId = currentUser.advisor.advisorId;

    const getAdvisorSecurityQuestionPromise = getAdvisorSecurityQuestion(
      advisorId
    );
    const getAdvisorSecurityQuestionListPromise = getAdvisorSecurityQuestionList(
      advisorId
    );

    Promise.all([
      getAdvisorSecurityQuestionPromise,
      getAdvisorSecurityQuestionListPromise,
    ]).then((results) => {
      const securityQuestion = results[0].data.payload;
      const securityQuestionList = results[1].data.payload;

      setState({
        isValid: true,
        securityQuestionList: securityQuestionList.map((question) => {
          return {
            id: question.id,
            question: question.question,
          };
        }),
        security: {
          question: {
            id: securityQuestion.questionNum,
            question:
              securityQuestion.questionNum !== null
                ? securityQuestionList[securityQuestion.questionNum].question
                : "",
          },
          answer: "",
          password: "",
        },
      });
    });
  }, []);

  const updateSecurityQuestions = (field) => (event) => {
    let newState = { ...state };
    newState.security[field] = event.target.value;
    setState(newState);
  };

  return (
    <Modal className={"security-questions-modal"}>
      <Grid
        container
        spacing={3}
        className={"user-profile-form security-questions"}
      >
        <Grid item xs={12}>
          <Typography variant={"h1"} component={"h1"}>
            Security Question
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <span>
            Security Question is required to reset your password. Please select
            a security question and answer before proceeding.
          </span>
        </Grid>
        {!state.isValid && (
          <Grid className={"invalid-security-question"} item xs={12}>
            <span>You must select a security question answer to continue.</span>
          </Grid>
        )}
        <Grid item xs={12}>
          <DropDownList
            label={"Security Question"}
            data={state.securityQuestionList}
            textField="question"
            dataItemKey="id"
            value={state.security.question}
            onChange={updateSecurityQuestions("question")}
          />
        </Grid>
        <Grid item xs={12}>
          <TextBox
            type={"password"}
            placeholder={"Answer"}
            value={state.security.answer}
            onChange={updateSecurityQuestions("answer")}
          />
        </Grid>
        <Grid item xs={12}>
          <div className={"button-container"}>
            <Button
              color={"primary"}
              variant={"contained"}
              onClick={() => {
                if (
                  state.security.question === null ||
                  state.security.answer === null ||
                  state.security.answer === ""
                ) {
                  setState({
                    ...state,
                    isValid: false,
                  });
                  return;
                }

                const currentUser = props.currentUser.toJS();
                const advisorId = currentUser.advisor.advisorId;

                saveSecurityQuestion(advisorId, {
                  questionNum: state.security.question.id,
                  answer: state.security.answer,
                  currentPassword: state.security.password,
                }).then((response) => {
                  props.hideSecurityQuestionModal();
                });
              }}
            >
              Save
            </Button>
          </div>
        </Grid>
      </Grid>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.currentUserReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideSecurityQuestionModal: () =>
      dispatch({
        type: HIDE_SECURITY_QUESTION_MODAL,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecurityQuestionModal);
